/* ═══════════════════════════════════════════════════════
   PRODUCT DESCRIPTION → AUTO ACCORDION  v3
   Place in: assets/description-accordion.js

   Scans product description for headers like:
     "Style description :"
     "Fabric & Care :"
     "Fit & Measurements :"

   Handles Word/MsoNormal formatting WITHOUT bold tags.
   ═══════════════════════════════════════════════════════ */

(function () {
  'use strict';

  function init() {
    var el = document.querySelector('.product__description');
    if (!el) return;

    var nodes = Array.from(el.childNodes).filter(function (n) {
      if (n.nodeType === 3) return n.textContent.trim().length > 0;
      return n.nodeType === 1;
    });

    if (!nodes.length) return;

    var sections = [];
    var currentSection = null;

    nodes.forEach(function (node) {
      var header = extractHeader(node);

      if (header) {
        if (currentSection) sections.push(currentSection);
        currentSection = { title: header, content: '' };
      } else if (currentSection) {
        currentSection.content += nodeHTML(node);
      } else {
        var h = nodeHTML(node);
        if (h.trim()) {
          currentSection = { title: 'Description', content: h };
        }
      }
    });

    if (currentSection) sections.push(currentSection);

    if (sections.length < 2) return;

    var html = '<div class="product-description-accordion">';
    sections.forEach(function (sec, i) {
      if (!sec.content.trim()) return;
      html += '<details' + (i === 0 ? ' open' : '') + '>';
      html += '<summary><h3>' + sec.title + '</h3><span class="accordion-icon"></span></summary>';
      html += '<div class="accordion-body">' + sec.content + '</div>';
      html += '</details>';
    });
    html += '</div>';

    el.innerHTML = html;
    el.classList.add('description--accordion-active');
  }

  function extractHeader(node) {
    if (node.nodeType !== 1) return null;

    var tag = node.tagName;
    var text = cleanText(node.textContent);

    if (!text || text.length > 60) return null;

    /* Bold/strong tags */
    if (tag === 'STRONG' || tag === 'B') {
      return checkHeader(text);
    }

    /* Paragraph or div */
    if (tag === 'P' || tag === 'DIV' || tag === 'SPAN') {
      /* Check for bold child first */
      var bold = node.querySelector('strong, b');
      if (bold) {
        var boldText = cleanText(bold.textContent);
        if (boldText && boldText.length >= text.length * 0.7) {
          return checkHeader(boldText);
        }
      }

      /* Plain paragraph that looks like a header */
      /* e.g. <p class="MsoNormal">Style description :&nbsp;</p> */
      var hasBlockChildren = node.querySelector('ul, ol, li, div, p, table, img');
      if (!hasBlockChildren && text.length < 40) {
        return checkHeader(text);
      }
    }

    /* Heading tags */
    if (/^H[2-6]$/.test(tag)) {
      return checkHeader(text);
    }

    return null;
  }

  function checkHeader(text) {
    if (!text) return null;

    /* Ends with ":" — definitely a header */
    if (text.endsWith(':')) {
      return text.replace(/:$/, '').trim();
    }

    /* Matches known patterns */
    var lower = text.toLowerCase();
    var patterns = [
      'style description', 'fabric & care', 'fabric and care', 'fabric care',
      'fit & measurements', 'fit and measurements', 'fit measurements',
      'shipping & returns', 'shipping and returns',
      'details', 'description', 'overview',
      'material', 'materials', 'composition',
      'care instructions', 'care', 'sizing', 'features',
      'about this product', 'product details', 'product information',
      'how to style', 'styling tips'
    ];

    for (var i = 0; i < patterns.length; i++) {
      if (lower === patterns[i]) return text;
    }

    return null;
  }

  function cleanText(str) {
    return str
      .replace(/\u00a0/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function nodeHTML(node) {
    if (node.nodeType === 1) return node.outerHTML;
    if (node.nodeType === 3) return node.textContent;
    return '';
  }

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

/* Shopify section reload fix */
document.addEventListener('shopify:section:load', function () {
  setTimeout(function () {
    var el = document.querySelector('.product__description');
    if (el) {
      el.classList.remove('description--accordion-active');
      init();
    }
  }, 50);
});

})();